export const colors = {
	black: 'black',
	claro: '#E9E9E9',
	oscuro: '#35404C',
	red: '#CB261A',
	white: '#E1D3C7',
	blanco: 'white'
};



// WEBPACK FOOTER //
// ./src/utils/colors.js